import { lazy } from "react";
import { getRoute } from "util/react";

export const OrderCancelledRoute = getRoute(
  { fullPath: "/:locale?/order-status/cancelled/:id" },
  "order-status/cancelled/:id",
  lazy(() => import("./cancelled")),
  null,
);

export const OrderSentToDriverRoute = getRoute(
  { fullPath: "/:locale?/order-status/sent-to-driver/:id" },
  "order-status/sent-to-driver/:id",
  lazy(() => import("./sentToDriver")),
  null,
);

export const OrderStatusRoute = getRoute(
  { fullPath: "/:locale?/order-status/:id" },
  "order-status/:id",
  lazy(() => import("./index")),
  null,
);

export const ShipmentStatusRoute = getRoute(
  { fullPath: "/:locale?/shipment-status/:id" },
  "shipment-status/:id",
  lazy(() => import("./shipment-status")),
  null,
);

export const OrderCancelledByDriverRoute = getRoute(
  { fullPath: "/:locale?/order-status/cancelled-by-driver/:id" },
  "order-status/cancelled-by-driver/:id",
  lazy(() => import("./cancelledByDriver")),
  null,
);

const OrderStatusesRoute = (
  <>
    {OrderCancelledRoute}
    {OrderSentToDriverRoute}
    {OrderStatusRoute}
    {OrderCancelledByDriverRoute}
    {ShipmentStatusRoute}
  </>
);

export default OrderStatusesRoute;
